import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOrgAuth: false,
  loggedOrg: {},
  organizations: [],
  organization: {},
  isSelectedOrg: false,
  isOrg: false,
  loading: false,
  isRoleUpdated: false,
};
const organizationSlice = createSlice({
  name: 'Organizatoin',
  initialState,
  reducers: {
    ResetOrganization: (state, action) => {
      state.isSelectedOrg = false;
      state.isOrg = false;
      state.isRoleUpdated = false;
      state.loading = false;
      // state.isOrgAuth = false;
    },
    LoadOrganization: (state, action) => {
      state.organizations = [...action.payload];
    },
    CreateOrganizationSuccess: (state, action) => {
      state.organizations.push(action.payload);
    },
    DeleteOrganization: (state, action) => {
      state.organizations = state.organizations.filter(
        org => org._id !== action.payload
      );
    },
    UpdateOrganizationSuccess: (state, action) => {
      const indexOfUpdate = state.organizations.findIndex(
        org => org._id === action.payload._id
      );
      state.organizations[indexOfUpdate] = { ...action.payload };
    },
    GetOneOrganization: (state, action) => {
      state.organization = state.organizations.find(
        org => org._id === action.payload
      );
      state.isSelectedOrg = true;
    },
    _GetOneOrganization: (state, action) => {
      state.organization = state.organizations.find(
        org => org._id === action.payload
      );
      state.isOrg = true;
    },
    updateRole: (state, action) => {
      const _indexOfUpdate = state.organizations.findIndex(
        org => org._id === action.payload._id
      );
      state.organizations[_indexOfUpdate] = { ...action.payload };
      state.organization = { ...action.payload };
      state.isRoleUpdated = true;
    },
    assignRoleToOrg: (state, action) => {},
    onOrgLogin: (state, action) => {
      state.isOrgAuth = true;
      state.loggedOrg = { ...action.payload };
      state.organization = { ...action.payload };
    },
    _roleUpdateRequest: (state, action) => {
      state.loading = true;
    },
    _roleUpdateSuccess: (state, action) => {
      state.loggedOrg = { ...action.payload, isOpen: false };
      state.organization = { ...action.payload, isOpen: false };
      state.loading = false;
      state.isRoleUpdated = true;
    },
    _onSelectRoleField: (state, action) => {},
  },
});
export default organizationSlice.reducer;
export const {
  LoadOrganization,
  CreateOrganizationSuccess,
  DeleteOrganization,
  ResetOrganization,
  GetOneOrganization,
  _GetOneOrganization,
  UpdateOrganizationSuccess,
  updateRole,
  assignRoleToOrg,
  onOrgLogin,
  _roleUpdateRequest,
  _roleUpdateSuccess,
} = organizationSlice.actions;
